module.exports = __webpack_public_path__ + "static/media/DAPC-2021-25.02d5bab5.pdf";